"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var material_1 = require("@mui/material");
var _1 = require(".");
var svgs_1 = require("../assets/svgs");
var UserMenu = function (_a) {
    var _b;
    var user = _a.user, handleLogoutClick = _a.handleLogoutClick, handleManageProfileClick = _a.handleManageProfileClick;
    var fullName = user.name;
    var _c = (0, react_1.useState)(false), open = _c[0], setOpen = _c[1];
    var _d = (0, react_1.useState)(false), parentHover = _d[0], setParentHover = _d[1];
    // const navigate = useNavigate()
    var userRole = function (roles) {
        if (roles === null || roles === void 0 ? void 0 : roles.is_admin) {
            return 'Admin';
        }
        else if (roles === null || roles === void 0 ? void 0 : roles.is_underwriter) {
            return 'Underwriter';
        }
        else if (roles === null || roles === void 0 ? void 0 : roles.is_broker) {
            return 'Broker';
        }
        return 'User';
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
            px: '2.8rem',
            marginBottom: '2.8rem',
            paddingLeft: '2.4rem',
            paddingRight: '2.4rem',
        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                    cursor: 'pointer',
                    padding: '1.6rem',
                    borderRadius: '0.4rem',
                    backgroundColor: !open ? 'transparent' : 'primary.main',
                    color: !open ? 'initial' : 'common.white',
                    ':hover': {
                        color: 'common.white',
                        backgroundColor: 'primary.main',
                    },
                }, onMouseOver: function () { return setParentHover(true); }, onMouseOut: function () { return setParentHover(false); }, onClick: function () {
                    setOpen(!open);
                }, "data-cy": "user-menu-toggle" }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", sx: {
                        alignItems: 'center',
                    } }, { children: [(0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(_1.ThemedAvatar, __assign({ size: "medium" }, { children: fullName.charAt(0).toUpperCase() })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ justifyContent: "space-between", sx: { paddingLeft: '1.2rem', paddingRight: '1.5rem' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "p", variant: "bodySmall", sx: {
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                width: '90px',
                                                textOverflow: 'ellipsis',
                                            } }, { children: fullName || (0, jsx_runtime_1.jsx)(_1.Skeleton, {}) })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "p", variant: "bodySmall", sx: {
                                                color: open || parentHover ? 'common.white' : 'primary.400',
                                            } }, { children: user ? userRole(user === null || user === void 0 ? void 0 : user.elpha) : (0, jsx_runtime_1.jsx)(_1.Skeleton, {}) }))] }))] }), (0, jsx_runtime_1.jsx)(svgs_1.UpDownChevronsSvg, {})] })) })), (0, jsx_runtime_1.jsx)(material_1.Collapse, __assign({ in: open, timeout: "auto", unmountOnExit: true }, { children: (0, jsx_runtime_1.jsx)(material_1.ClickAwayListener, __assign({ onClickAway: function () { return setOpen(false); } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Paper, __assign({ sx: { borderRadius: '0px' } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.MenuList, __assign({ sx: {
                                    py: '1.4rem',
                                    '.MuiMenuItem-root': {
                                        color: 'primary.400',
                                        '&:hover': {
                                            background: 'none',
                                            color: 'primary.600',
                                            path: {
                                                stroke: '#191933',
                                            },
                                        },
                                    },
                                } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.MenuItem, __assign({ onClick: handleManageProfileClick }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, { children: (0, jsx_runtime_1.jsx)(svgs_1.UserSvg, { width: "20", height: "20" }) }), (0, jsx_runtime_1.jsx)(material_1.ListItemText, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "bodySmall" }, { children: "Manage Profile" })) })] })), (0, jsx_runtime_1.jsxs)(material_1.MenuItem, __assign({ onClick: handleLogoutClick, "data-cy": "user-menu-logout" }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, { children: (0, jsx_runtime_1.jsx)(svgs_1.LogoutSvg, { width: "20", height: "20" }) }), (0, jsx_runtime_1.jsx)(material_1.ListItemText, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "bodySmall" }, { children: "Logout" })) })] }))] })), (0, jsx_runtime_1.jsx)(material_1.Divider, { sx: { background: '#EAF0FE' } }), (0, jsx_runtime_1.jsxs)(material_1.MenuList, __assign({ sx: {
                                    py: '1.4rem',
                                    '.MuiMenuItem-root': {
                                        color: 'primary.400',
                                        '&:hover': {
                                            background: 'none',
                                            color: 'primary.600',
                                        },
                                    },
                                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ onClick: function () {
                                            window.open('https://help.elphasecure.com/');
                                        } }, { children: (0, jsx_runtime_1.jsx)(material_1.ListItemText, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "bodySmall" }, { children: "Help Center" })) }) })), ((_b = user.elpha) === null || _b === void 0 ? void 0 : _b.is_admin) && ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ onClick: function () {
                                            window.open('https://eriskhub.com/elphasecure');
                                        } }, { children: (0, jsx_runtime_1.jsx)(material_1.ListItemText, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "bodySmall" }, { children: "Security Resources" })) }) })))] }))] })) })) }))] })));
};
exports.UserMenu = UserMenu;
